import React from "react";
import { useLang } from "../i18n/LanguageContext";
import { MapPin } from "lucide-react";

export default function ServiceAreas() {
  const { t } = useLang();
  return (
    <section id="areas" data-testid="areas-section" className="relative bg-neutral-950 py-24 sm:py-32 border-t border-neutral-900 overflow-hidden">
      <div className="absolute inset-0 opacity-[0.04] pointer-events-none">
        <div className="w-full h-full" style={{ backgroundImage: "linear-gradient(#fff 1px, transparent 1px), linear-gradient(90deg, #fff 1px, transparent 1px)", backgroundSize: "60px 60px" }} />
      </div>

      <div className="relative max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 grid lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-5">
          <div className="flex items-center gap-3 text-orange-500 font-mono-label text-xs uppercase tracking-[0.25em] mb-5">
            <span className="w-8 h-px bg-orange-500" /> {t.areas.label}
          </div>
          <h2 className="font-display uppercase text-white text-4xl sm:text-5xl lg:text-6xl leading-[0.95] whitespace-pre-line">
            {t.areas.title}
          </h2>
          <div className="mt-8 flex items-center gap-3 text-neutral-300">
            <MapPin className="text-orange-500" size={18} />
            <span className="font-mono-label text-sm uppercase tracking-wide">33.5186° N, 86.8104° W</span>
          </div>
        </div>

        <div className="lg:col-span-7">
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-px bg-neutral-900 border border-neutral-900">
            {t.areas.list.map((city, i) => (
              <div
                key={i}
                data-testid={`area-${i}`}
                className="group bg-neutral-950 hover:bg-neutral-900 p-5 sm:p-6 flex items-center justify-between transition-colors"
              >
                <span className="font-display uppercase text-white text-base sm:text-lg tracking-tight">{city}</span>
                <span className="font-mono-label text-[10px] text-neutral-600 group-hover:text-orange-500 transition-colors">AL</span>
              </div>
            ))}
          </div>
          <p className="mt-6 text-neutral-500 text-sm">
            Don&apos;t see your area? Call <a href="tel:+12055383654" className="text-orange-500 hover:underline">(205) 538-3654</a> — we likely cover it.
          </p>
        </div>
      </div>
    </section>
  );
}
